/**
 * Via `window.kazoo.i18n`.
 */
export type I18nProps = {
  language: string;
  resources: ResourceLanguage;
};

// Duplicated out of the i18next package for better decoupling
interface ResourceLanguage {
  [namespace: string]: ResourceKey;
}

type ResourceKey =
  | string
  | {
      [key: string]: any;
    };

type TFunctionResult = React.ReactNode | string | null | undefined;
type TFunctionKeys = string | TemplateStringsArray;

export interface TFunction {
  // basic usage
  <
    TResult extends TFunctionResult = string,
    TKeys extends TFunctionKeys = string
  >(
    key: TKeys | TKeys[],
    options?: any | string
  ): TResult;
  // overloaded usage
  <
    TResult extends TFunctionResult = string,
    TKeys extends TFunctionKeys = string
  >(
    key: TKeys | TKeys[],
    defaultValue?: string,
    options?: any | string
  ): TResult;
}
